import {
  Box,
  Container,
  CssBaseline,
  OutlinedInput,
  ThemeProvider,
  Typography,
} from "@mui/material";
import theme from "../../../config/theme";
import { StyledFormControl } from "../../../components/common/FormControl";
import { Email, Lock, Visibility } from "@mui/icons-material";
import { StyledButton } from "../../../components/common/Button";
import { useState } from "react";
import { StyledBox } from "../../ledger/components/Welcome";
import { Auth } from "aws-amplify";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const signUp = async () => {
    setLoading(true);
    try {
      await Auth.signUp({
        username: formData.email,
        password: formData.password,
        attributes: {
          name: formData.email,
          email: formData.email,
          phone_number: formData.phoneNumber,
          "custom:type": formData.type,
        },
      });
      enqueueSnackbar("Signup was successful.", { variant: "success" });
      setLoading(false);
      navigate("/successful");
    } catch (e) {
      console.log(e);
      enqueueSnackbar("Something went wrong", { variant: "error" });
      setLoading(false);
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const fields = ["email", "password", "confirm password"];
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container sx={{ display: "flex", justifyContent: "center" }}>
        <StyledBox style={{ marginTop: "8rem" }}>
          <Typography
            variant="h4"
            sx={{
              marginTop: "3.25rem",
              fontWeight: 600,
              fontSize: "1.875rem",
              color: "#212121",
              letterSpacing: "0.015625rem",
            }}
          >
            Create an account
          </Typography>
          <Typography
            variant="h6"
            sx={{
              marginTop: "1.25rem",
              fontWeight: 400,
              fontSize: "1.125rem",
              color: "#6A6A6A",
              letterSpacing: "0.009375rem",
            }}
          >
            Enter your details
          </Typography>
          <StyledFormControl
            sx={{
              marginTop: "3.8125rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {fields.map((field, index) => (
              <Box
                key={index}
                sx={{
                  height: "3rem",
                  width: "21rem",
                  background: "#EEF6FF",
                  border: `1px solid ${
                    index === 0 ? theme.palette.primary.main : "#6A6A6A"
                  }`,
                  marginBottom: index === fields.length - 1 ? 0 : "0.8125rem",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "0.5rem",
                  padding: "0.75rem 0 0.75rem 1rem",
                }}
              >
                {index === 0 ? (
                  <Email
                    sx={{
                      height: "1.5rem",
                      width: "1.125rem",
                      color: `${theme.palette.primary.main}`,
                    }}
                  />
                ) : (
                  <Lock
                    sx={{
                      height: "1.5rem",
                      width: "1rem",
                      color: `${theme.palette.primary.main}`,
                    }}
                  />
                )}
                <OutlinedInput
                  type={
                    index === 0
                      ? "email"
                      : index === 1
                      ? "password"
                      : showPassword
                      ? "text"
                      : "password"
                  }
                  placeholder={
                    index === 0
                      ? "abcd@gmail.com"
                      : index === 1
                      ? "Password"
                      : "Confirm Password"
                  }
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                />
                {index === 2 && (
                  <Visibility
                    onClick={handleTogglePassword}
                    sx={{
                      height: "1.5rem",
                      width: "1.3125rem",
                      marginLeft: "1.125rem",
                      color: `${theme.palette.primary.main}`,
                      cursor: "pointer",
                    }}
                  />
                )}
              </Box>
            ))}
          </StyledFormControl>
          <Typography>
            <StyledButton
              style={{
                backgroundColor: `${theme.palette.primary.main}`,
                height: "3rem",
                width: "21rem",
                marginTop: "1.25rem",
                borderRadius: "1.5rem",
                color: "#FFFFFF",
                letterSpacing: "0.078125rem",
              }}
              onClick={signUp}
              disabled={loading}
            >
              {loading ? "Loading..." : "NEXT"}
            </StyledButton>
          </Typography>
        </StyledBox>
      </Container>
    </ThemeProvider>
  );
};

export default Register;
